export const MESSAGE_QUERY_KEY = "message";
